import { Modal, StyleSheet, Text, View, type GestureResponderEvent } from 'react-native';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	buttonText?: string;
	hideResetButton?: boolean;
	isLoading?: boolean;
	onPress: (event: GestureResponderEvent) => void;
	onPressReset?: (event: GestureResponderEvent) => void;
	resetText?: string;
	text?: string;
	title?: string;
	visible?: boolean;
}

const ResetPasswordDialog = ({
	buttonText,
	hideResetButton = false,
	isLoading = false,
	onPress,
	onPressReset,
	resetText,
	text,
	title,
	visible,
}: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<View style={dialogStyles.centeredView}>
				<View style={{ ...dialogStyles.modalCard, alignItems: 'center' }}>
					<Text style={dialogStyles.modalTitle}>{title}</Text>
					<Text style={dialogStyles.modalDescription}>{text}</Text>

					<View style={styles.buttonRow}>
						<SecondaryButton label={buttonText} onPress={onPress} />
						{!hideResetButton ? (
							<PrimaryButton
								extraStyle={{ flex: Dimens.flex1 }}
								iconSize={Dimens.iconSize21}
								label={resetText}
								loading={isLoading}
								onPress={onPressReset}
							/>
						) : undefined}
					</View>
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	buttonRow: {
		flexDirection: 'row',
		gap: Dimens.gap20,
	},
});

export default ResetPasswordDialog;
